<template>
  <div id="map-data">
    <div class="map-data-title">
      {{$t("deviceMap")}}
    </div>
    <div id="map-data-content"></div>
  </div>
</template>

<script>

  import {
    getAttributesServer,
    getAttributesShared,
    getCredentials,
    getDeviceName,
    getConnectTime,
    getAttributesClient,
    getTimeDeviceHistory
  } from "../untils/api/home"
  import moment from "moment";
  export default {
    name :'MapData',
    components: {},
    data() {
      return {
        map: '',
        markList:[], //全部点
        markers:[],
        shareList: [],
        name: '',
        key: '',
        mapDayRain: '',
        currentInfoWindow: null
      }
    },

    mounted() {
      this.loadTianditu();
    },

    methods: {
      loadTianditu() {
        if (typeof T !== 'undefined') {
          this.initMap();
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://api.tianditu.gov.cn/api?v=4.0&tk=b605394410079145db1525d2c8fa27aa';
        script.onload = () => {
          setTimeout(() => this.initMap(), 50);
        };
        document.body.appendChild(script);
      },

      initMap() {
        try{
          const center = new T.LngLat(103.817535, 36.132308);
          this.map = new T.Map('map-data-content');
          this.map.centerAndZoom(center, 4);
          this.map.enableScrollWheelZoom();
          document.getElementsByClassName("tdt-control-copyright tdt-control")[0].style.display = 'none'
        }catch (e) {
          console.error('initMap error', e);
        }

        this.map.addEventListener('click', () => {
          if (this.currentInfoWindow) {
            this.map.closeInfoWindow(this.currentInfoWindow);
            this.currentInfoWindow = null;
          }
        });
      },
      /**
       * 获取服务端共享端位置
       * @param deviceBoards
       * @param key
       */
      getDeviceSite(deviceBoards, key) {
        this.key = key;
        this.markList = [];
        this.markers = [];
        this.setServerPoint(deviceBoards); // 获取服务端位置
        this.setSharePoint(deviceBoards); // 获取共享端位置
      },

      /**
       * 获取服务端经纬度
       * @param deviceBoards
       */
      setServerPoint(deviceBoards){
        let offLine = 0;
        for (let i = 0; i < deviceBoards.length; i++) {
          let option = {};
          let latFlg = false;
          let lngFlg = false;
          let beforeTime = new Date(moment().subtract(1, "hours")).getTime();//一小时之前时间
          getAttributesServer(deviceBoards[i].type, deviceBoards[i].id).then(response => {//获取服务端数据
            //遍历每一条数据
            for (let j = 0; j < response.length; j++) {
              if (response[j].key === 'latitude') {// 纬度
                option.lat = response[j].value;
                option.device = deviceBoards[i];
                option.showFlag = false;
                latFlg = true;
              } else if(response[j].key === 'longitude'){//经度
                //当前对象为纬度赋值
                option.lng = response[j].value;
                lngFlg = true;
              } else if(response[j].key === 'lastConnectTime'){//最后一次更新时间
                if(response[j].value <= beforeTime){
                  option.url = require("./img/map1.png");
                  offLine++;
                  this.$emit("callOffLine", offLine);
                } else {
                  option.url = require("./img/map2.png");
                }
              }
              //经度纬度数据赋值给集合
              if(lngFlg && latFlg){
                let existItem = this.markList.find(m => m.device.id === option.device.id);
                if (existItem) {
                  let idx = this.markList.indexOf(existItem);
                  this.markList[idx] = option;
                  this.updateMarker(option);
                } else {
                  this.markList.push(option);
                  this.addSingleMarker(option);
                }
                break;
              }
            }
          }).catch(error => {
            console.log("error", error)
          })
        }
      },

      /**
       * 获取共享端数据
       * @param deviceBoards
       */
      setSharePoint(deviceBoards) {
        Promise.all([
          //获取每一个设备最后一次连接时间
          this.connectTime(deviceBoards),
        ]).then(res => {
          //遍历循环出每一个设备
          for(let i = 0; i < deviceBoards.length; i++){
            let option = {};
            let latFlg = false;
            let lngFlg = false;
            let beforeTime = new Date(moment().subtract(1, "hours")).getTime();//一小时之前时间
            //访问api获取数据
            getAttributesShared(deviceBoards[i].type, deviceBoards[i].id).then(response => {
              for(let j = 0; j < response.length; j++){
                let flag = false;
                //当前对象为纬度 赋值
                if(response[j].key === 'latitude') {
                  option.lat = response[j].value;
                  option.device = deviceBoards[i];
                  option.showFlag = false;
                  latFlg = true;
                  //循环查找出当前设备是否离线
                  for(let z = 0; z < this.shareList.length; z++){
                    if(this.shareList[z].id === deviceBoards[i].id){
                      this.shareList[z].value <= beforeTime ? flag = true : flag = false;
                      break;
                    }
                  }
                  //根据设备是否离线设置不同坐标
                  if(flag){
                    option.url = require("./img/map1.png");
                  } else {
                    option.url = require("./img/map2.png");
                  }
                  if(lngFlg && latFlg){
                    this.markList.push(option);
                  }
                } else if(response[j].key === 'longitude'){
                  //当前对象为纬度赋值
                  option.lng = response[j].value;
                  lngFlg = true;
                }
                if(lngFlg && latFlg){//经度纬度数据赋值给集合
                  let existItem = this.markList.find(m => m.device.id === option.device.id);
                  if (existItem) {
                    let idx = this.markList.indexOf(existItem);
                    this.markList[idx] = option;
                    this.updateMarker(option);
                  } else {
                    this.markList.push(option);
                    this.addSingleMarker(option);
                  }
                  break;
                }
              }
            }).catch(error => {
              console.log("error", error);
            })
          }
        })
      },

      /**
       * 获取所有设备最后一次更新时间
       * @param deviceBoards
       */
      connectTime(deviceBoards){
        this.shareList = [];
        for(let i = 0; i < deviceBoards.length; i++){
          getConnectTime(deviceBoards[i].type, deviceBoards[i].id).then(response => {
            let shareJson = {};
            shareJson.id = deviceBoards[i].id;
            shareJson.value = response[0].value;
            this.shareList.push(shareJson);
          }).catch(error => {
            console.log("error", error)
          })
        }
      },

      addSingleMarker(item) {
        if (!this.map || typeof this.map.addOverLay !== "function") {
          console.log("map 未 ready，延迟 100ms 再试一次");
          setTimeout(() => this.addSingleMarker(item), 100);
          return;
        }
        const point = new T.LngLat(item.lng, item.lat);
        const icon = new T.Icon({
          iconUrl: item.url,
          iconSize: new T.Point(22, 33),
          iconAnchor: new T.Point(11, 33)
        });
        const marker = new T.Marker(point, { icon });
        marker.device = item.device;

        marker.addEventListener('click', async () => {
          // const cred = await getCredentials(item.device.id);
          // const boundaryNum = await this.getBoundaryFromClient(cred.credentialsId);
          // const mapDayRain = await this.getDayRain(boundaryNum, cred);
          // const html = `<b>${item.device.name}</b>`;
          // const infoWindow = new T.InfoWindow(html, { offset: new T.Point(0, -30) });
          // this.map.openInfoWindow(infoWindow, point);
          // this.currentInfoWindow = infoWindow;

          try {
            item.showFlag = true;

            const infoWindow = new T.InfoWindow("<div>加载中...</div>", { offset: new T.Point(0, -30) });
            this.map.openInfoWindow(infoWindow, marker.getLngLat());
            this.currentInfoWindow = infoWindow;

            // 1. 获取设备凭证信息
            const cred = await getCredentials(item.device.id);

            // 2. 获取 boundaryNum
            const boundaryNum = await this.getBoundaryFromClient(cred.credentialsId);

            // 3. 获取当天雨量
            const mapDayRain = await this.getDayRain(boundaryNum, cred);

            // 4. 构建 InfoWindow HTML
            const html = `
      <div style="color:#fff; font-size:14px; text-align:center;">
        <div style="font-size:18px; color:#000000;">
          ${item.device.name}
        </div>
        <table style="margin:0 auto; color:#000000;">
          <tr>
            <td style="font-size:16px;">${this.$t("dayRainfall")}&nbsp;&nbsp;&nbsp;</td>
            <td style="font-size:16px;">${mapDayRain} mm</td>
          </tr>
        </table>
        <div style="margin-top:5px;">
          <button style="background:none;border: none;color: #1890ff;cursor: pointer;font-size: 16px; padding-right: 10px;" id="btnUpdate">${this.$t("dataUpdate")}</button>
          <button style="background:none;border: none;color: #1890ff;cursor: pointer;font-size: 16px;" id="btnClose">${this.$t("close")}</button> </div>
        </div>
      </div>
    `;

            // 5. 创建 InfoWindow 并打开
            infoWindow.setContent(html);

            // 6. 绑定按钮事件
            setTimeout(() => {
              const btnUpdate = document.getElementById("btnUpdate");
              const btnClose = document.getElementById("btnClose");

              if (btnUpdate) btnUpdate.onclick = () => this.changeDevice(marker);
              if (btnClose) btnClose.onclick = () => this.infoWindowClose(marker);
            }, 50);
          } catch (err) {
            console.error("infoWindow error:", err);
          }
        });

        this.map.addOverLay(marker);
        this.markers.push(marker);
      },

      updateMarker(option) {
        const marker = this.markers.find(m => m.device.id === option.device.id);
        if (marker) {
          const point = new T.LngLat(option.lng, option.lat);
          marker.setLngLat(point);
          marker.setIcon(new T.Icon({
            iconUrl: option.url,
            iconSize: new T.Point(22, 33),
            iconAnchor: new T.Point(11, 33)
          }));
        }
      },

      /**
       * 切换设备
       * @param marker
       */
      changeDevice(marker){
        this.$emit("callBack", marker.device);
        marker.showFlag = false;
      },

      /**
       * 获取日分界时
       * @param credentialsId
       * @param deviceInfo
       */
      async getBoundaryFromClient(credentialsId) {
        const response = await getAttributesClient(credentialsId);
        let boundaryNum = 0;

        for (let obj in response.client) {
          if (obj === 'rainHour') {
            boundaryNum = response.client[obj];
            break;
          }
        }
        return boundaryNum;
      },

      /**
       * 获取日雨量
       * @param boundaryNum
       * @param deviceInfo
       */
      async getDayRain(boundaryNum, deviceInfo) {
        let format = 'YYYY-MM-DD ' + boundaryNum + ':00:00';
        let startTime = new Date(moment().startOf('day').subtract(1,"days").format(format)).getTime();
        let endTime = new Date(moment().startOf('day').format(format)).getTime();

        const response = await getTimeDeviceHistory(deviceInfo.deviceId.entityType, deviceInfo.deviceId.id, this.key, startTime, endTime, 0, 'NONE');

        if (JSON.stringify(response) === "{}") return "-";

        let mapDayRain = "-";

        for (let obj in response) {
          let index = '';
          for(let i=0;i<response[obj].length-1;i++){
            if(parseFloat(response[obj][i].value)===0 && parseFloat(response[obj][i+1].value)!==0){
              index = i;
              break;
            }
          }
          if(index === '') {
            mapDayRain = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
          } else {
            mapDayRain = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2);
          }
        }

        return mapDayRain;
      },

      infoWindowClose (marker) {
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
          this.currentInfoWindow = null;
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "less/MapData.less";
</style>



// WEBPACK FOOTER //
// src/components/MapData.vue